import 'dayjs/locale/tr';
import 'dayjs/locale/de';
import 'dayjs/locale/es';
import 'dayjs/locale/pl';
import 'dayjs/locale/fr';
import 'dayjs/locale/it';
import 'dayjs/locale/el';
import 'dayjs/locale/bg';
import 'dayjs/locale/ro';
import 'dayjs/locale/hu';
import 'dayjs/locale/zh-cn';
import 'dayjs/locale/hi';
import 'dayjs/locale/cs';
import 'dayjs/locale/hr';
import 'dayjs/locale/lt';
import 'dayjs/locale/lv';
import 'dayjs/locale/sk';
import 'dayjs/locale/sl';

import { dayjs } from 'common/dayjs';
import { FeatureFlagsContextProvider } from 'components/FeatureFlags/FeatureFlagsContextProvider';
import { OverlayContainerContextProvider } from 'components/OverlayContainer/OverlayContainerContextProvider';
import { AntThemeProvider } from 'core/app/ant/AntThemeProvider/AntThemeProvider';
import { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { AppRouter } from './AppRouter';
import { preloadRoutes } from './utils';

export const App: FC = () => {
  const { i18n } = useTranslation();

  useEffect(() => {
    const locale = i18n.language === 'cn' ? 'zh-cn' : i18n.language;
    dayjs.locale(locale);
    dayjs.updateLocale(locale, { weekStart: 1 });
  }, [i18n.language]);

  useEffect(() => {
    const id = setTimeout(() => {
      void preloadRoutes();
    }, 10000);

    return () => {
      clearTimeout(id);
    };
  }, []);

  return (
    <AntThemeProvider>
      <FeatureFlagsContextProvider>
        <OverlayContainerContextProvider>
          <AppRouter />
        </OverlayContainerContextProvider>
      </FeatureFlagsContextProvider>
    </AntThemeProvider>
  );
};
